import { combineReducers } from "@reduxjs/toolkit";
import alternativeWorkingDayList from "./alternativeWorkingDayListSlice";

const reducer = combineReducers({
  alternativeWorkingDayList,
});

export default reducer;
